/**
 * Slash commands for the message box: typing "/" lists them, and picking one fills in its message with the part to
 * complete, written in [brackets], selected so the user types over it. Which commands exist is the app's business
 * (apps/web builds them from the tenant's funds and specialists); matching and filling live here with the menu.
 */
export interface SlashCommand {
  name: string;
  description: string;
  template: string;
}

/** The commands a message box holding `input` should offer, or null when it is not typing a command: "/" then letters, no space. */
export function matchSlash(input: string, commands: SlashCommand[]): SlashCommand[] | null {
  const typed = /^\/(\S*)$/.exec(input);
  if (!typed) return null;
  const prefix = typed[1]!.toLowerCase();
  return commands.filter((command) => command.name.startsWith(prefix));
}

/** A command's message with its brackets dropped, and the range to select: the part to complete, else the end. */
export function fillTemplate(template: string): { text: string; selection: [number, number] } {
  const slot = /\[([^\]]+)\]/.exec(template);
  if (!slot) return { text: template, selection: [template.length, template.length] };
  const text = template.slice(0, slot.index) + slot[1] + template.slice(slot.index + slot[0].length);
  return { text, selection: [slot.index, slot.index + slot[1]!.length] };
}
